import { transactionsApi } from '../../utils/urls';
import { API_STATUS_ALL_TRANSACTIONS } from '../../utils/constants';
import { rootApi } from '../../services/rootApi';

export const transactionsApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchTransactions: builder.query({
      query: () => ({
        url: transactionsApi(),
        method: 'POST',
        body: {
          data: {
            sortBy: 'date',
            sortMode: 'desc',
            status: API_STATUS_ALL_TRANSACTIONS
          },
          method: 'read'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: ['Transactions'],
    }),
    resendReceipt: builder.mutation({
      query: (id) => ({
        url: transactionsApi(),
        method: 'POST',
        body: {
          data: { id },
          method: 'resendReceipt'
        },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['Transactions'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchTransactionsQuery,
  useResendReceiptMutation,
} = transactionsApiSlice; 